var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.77393 2.70834C5.97697 2.70834 2.89893 5.78639 2.89893 9.58334C2.89893 13.3803 5.97697 16.4583 9.77393 16.4583C13.5709 16.4583 16.6489 13.3803 16.6489 9.58334C16.6489 5.78639 13.5709 2.70834 9.77393 2.70834ZM1.64893 9.58334C1.64893 5.09603 5.28661 1.45834 9.77393 1.45834C14.2612 1.45834 17.8989 5.09603 17.8989 9.58334C17.8989 14.0707 14.2612 17.7083 9.77393 17.7083C5.28661 17.7083 1.64893 14.0707 1.64893 9.58334Z",
    fill: "#64748B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3465 14.5462C14.5903 14.3018 14.986 14.3013 15.2304 14.5451L18.1671 17.4742C18.4115 17.7179 18.412 18.1136 18.1683 18.358C17.9245 18.6024 17.5288 18.6029 17.2844 18.3592L14.3477 15.4301C14.1033 15.1864 14.1028 14.7906 14.3465 14.5462Z",
    fill: "#64748B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.85d7978f0f844156f45227b94fb8f81b.svg";
export { ForwardRef as ReactComponent };